export const VoucherResources = {
  ggcTitle: "Otrzymałeś eKartę podarunkową goodie na kwotę {amount} PLN.",
  ggcDescription: "Aby korzystać z kart otwórz aplikację goodie. Jeżeli nie masz aplikacji, pobierz ją ze sklepu.",

  cshbTitle: "Twój kod zawiera {amount} PLN bonusowego cashbacku.",
  cshbDescription: "Aby go odebrać przejdź do sekcji cashback, zrób zakupy z goodie i ciesz się z bonusu.",

  mobileDescription: "Aby korzystać z karty odbierz i aktywuj ją.",

  cbButtonText: "Przejdź do cashback",

  faqTitle: "NAJCZĘŚCIEJ ZADAWANE PYTANIA",

  activationTimeDescription: "Aktywuj kartę w aplikacji goodie przed {date}",
};
